<template>
    <div class="special-container">
        <div class="special" :class="{hide: hide}">
            <wp-image :image="image"
                      class="image-container"
                      :is-background="true"
                      :size-hd="`special-hd`"
                      :load-immediate="true"
                      @loaded="showSpecial"
            ></wp-image>
            <div class="content-container">
                <content-block :body="body"
                               :button="button"
                               :section_heading="title"
                ></content-block>
                <div class="close-icon" @click="hideSpecial">
                    <font-awesome-icon :icon="closeIcon" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ContentBlock from './ContentBlock'
    import { faTimes }  from '@fortawesome/pro-light-svg-icons/faTimes'

    export default {
        name: "Special",
        components: { ContentBlock },
        props: {
            body: String,
            button: Object,
            image: Object,
            title: String
        },
        data() {
            return {
                hide: false
            }
        },
        computed: {
            closeIcon() {
                return faTimes
            }
        },
        methods: {
            showSpecial() {
                console.log('image ready')
            },
            hideSpecial() {
                this.hide = true
            }
        }
    }
</script>

<style lang="scss" scoped>

    .special-container {
        position: relative;
        width: 100%;
        height: 100%;
        @include site-container;
    }

    .special {
        display: flex;
        height: min-content;
        background: $white;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.22);
        opacity: 1;
        transition: all 300ms;

        @media (min-width: $bp-small) {
            position: absolute;
            right: 0;
            width: 60%;
            max-width: 800px;
            transform: matrix(1, 0, 0, 1, 0, -280);
        }

        @media (min-width: $bp-desktop) {
            right: 40px;
        }
    }

    .image-container {
        background: no-repeat center;
        background-size: cover;
        width: 30%;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,0.22);
    }

    .content-container {
        width: 70%;
        padding: 75px 50px;
        display: flex;
        align-items: center;

        @media (min-width: $bp-desktop) {
            padding: 75px 105px 75px 75px;
        }

        /deep/ .content-block {
            padding: 0;

            > .block {
                padding: 0;
            }

            .button {
                margin-top: 25px;
            }
        }
    }

    .close-icon {
        color: #D7D8DF;
        font-size: 30px;
        position: absolute;
        top: 25px;
        right: 30px;

        &:hover {
            cursor: pointer;
            color: $color2;
        }
    }

    .hide {
        opacity: 0;
        pointer-events: none;
    }

</style>